import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export const useLogs = () => {
  return useQuery({
    queryKey: ['logs'],
    queryFn: () =>
      axios
        .get(envApiUrl + '/logs', {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => response.data),
  });
};
